<template>
  <div class="tree">
    <div @click="getpush('journeyList')">
      <van-row class="list-user">
        <van-col span="4">
          <div class="msg">
            <img class="img" src="../../../assets/rount.png" alt="" />
          </div>
        </van-col>
        <van-col span="11" offset="2">我的行程</van-col>
      </van-row>
    </div>
    <div @click="getpush('InvoiceHomePage')">
      <van-row class="list-user">
        <van-col span="4">
          <div class="msg">
            <img class="img" src="../../../assets/paper.png" alt="" />
          </div>
        </van-col>
        <van-col span="11" offset="2">开具发票</van-col>
      </van-row>
    </div>
    <div @click="getpush('HelpCenter')">
      <van-row class="list-user">
        <van-col span="4">
          <div class="msg">
            <img class="img" src="../../../assets/help.png" alt="" />
          </div>
        </van-col>
        <van-col span="11" offset="2">帮助中心</van-col>
      </van-row>
    </div>
    <div @click="getpush('AccountPage')" v-show="channelTypeTitle">
      <van-row class="list-user">
        <van-col span="4">
          <div class="msg">
            <img class="img" src="../../../assets/set.png" alt="" />
          </div>
        </van-col>
        <van-col span="11" offset="2">账号管理</van-col>
      </van-row>
    </div>
    <div class="phone2" @click="phoneCall()">
      <van-row class="list-user">
        <van-col span="4">
          <div class="msg">
            <img class="img" src="../../../assets/phone2.png" alt="" />
          </div>
        </van-col>
        <van-col v-if='channelTypeTitle' span="11">400-920-9966</van-col>
        <van-col v-else span="11">400-039-0810</van-col>
      </van-row>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import {
  Row,Col,
} from "vant";
Vue.use(Row).use(Col);

export default {
  name: "tree",
  props: ['channelTypeTitle'],
  data: () => ({

  }),
  mounted() {
    
  },
  methods: {
    getpush(_url) {
      this.$emit('getpush', _url);
    },
    phoneCall() {
     window.location.href = "tel:4009209966";
    },
  }
}
</script>
<style lang="scss" scoped>
  .tree {
    position: fixed;
    top: 0;
    left: 0;
    width: 60%;
    height: 100%;
    z-index: 99999999;
    background-color: #fff;
    color: #4e4e4e;
    .list-user {
      margin-top: 10px;
      text-align: left;
      font-size: 15px;
      height: 50px;
      line-height: 50px;
      .msg {
        width: 13px;
        height: 13px;
        margin-left: 20px;
        margin-top: 2px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .phone2 {
      position: fixed;
      width: 100%;
      bottom: 20px;
      .list-user {
        margin-top: 10px;
        text-align: left;
        font-size: 15px;
        height: 50px;
        line-height: 50px;
        .msg {
          width: 13px;
          height: 13px;
          margin-left: 20px;
          margin-top: 2px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Home/components/userInfo.vue